import React, { ReactNode } from "react";

import { Button } from "@/components/atoms/buttons/Button";
import {
  Modal,
  ModalFoot,
  ModalHead,
  Sizes,
} from "@/components/molecules/modals/Modal";

interface Props {
  title: string;
  isOpen: boolean;
  handleClose: () => void;
  handleClear: () => void;
  handleSearch: () => void | Promise<void>;
  children?: ReactNode;
}

/**
 * 検索モーダル
 */
export default function SearchModal({
  title,
  isOpen,
  handleClose,
  handleClear,
  handleSearch,
  children,
}: Props) {
  return (
    <Modal
      size={Sizes.XXXXL}
      spSize="full"
      isOpen={isOpen}
      handleClose={handleClose}
    >
      <div className="grid grid-rows-[auto_1fr_auto] min-h-screen">
        <ModalHead title={title} onClickClose={handleClose} />
        <div>{children}</div>
        <ModalFoot className="space-x-4">
          <Button
            size="sm"
            onClick={handleClear}
            color="cancel"
            label="すべてクリア"
          />
          <Button
            size="sm"
            color="primary"
            onClick={handleSearch}
            label="検索"
          />
        </ModalFoot>
      </div>
    </Modal>
  );
}
